import React, { FC } from 'react';
import {
  checkPropsItemForType,
  checkPropsItemForTypes,
  isDocumentFile,
  isFolder,
  isMusicFile,
  isPictureFile,
  isPublicOrShutterstockVideoFile,
  isSWFFile,
  isTransparentVideoFile,
  isVideoFile,
  isZipFile,
  is3dFile,
} from '../../../utils/media-manager-sdk/items';
import { Empty } from './Demonstrations/Empty';
import { Folder } from './Demonstrations/Folder';
import { Labeled } from './Demonstrations/Labeled';
import { Music } from './Demonstrations/Music';
import { Picture } from './Demonstrations/Picture';
import { PublicVideo } from './Demonstrations/PublicVideo';
import { Video } from './Demonstrations/Video';
import { VideoAlpha } from './Demonstrations/VideoAlpha';
import { IOuter } from './ItemDemonstration.types';

const chooseDemonstrationComponent = (props) => {
  if (checkPropsItemForTypes([isDocumentFile, isSWFFile, isZipFile])(props)) {
    return Labeled;
  }

  if (checkPropsItemForType(isMusicFile)(props)) {
    return Music;
  }

  if (checkPropsItemForType(isPictureFile)(props)) {
    return Picture;
  }

  if (checkPropsItemForType(is3dFile)(props)) {
    return Picture;
  }

  // should be above video, because they share media type for some reason
  if (checkPropsItemForType(isTransparentVideoFile)(props)) {
    return VideoAlpha;
  }

  if (checkPropsItemForType(isPublicOrShutterstockVideoFile)(props)) {
    return PublicVideo;
  }

  if (checkPropsItemForType(isVideoFile)(props)) {
    return Video;
  }

  if (checkPropsItemForType(isFolder)) {
    return Folder;
  }

  return Empty;
};

export const ItemDemonstration: FC<IOuter> = (props) => {
  const Demonstration = chooseDemonstrationComponent(props);

  return <Demonstration {...props} />;
};
